<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>
                  Book not returned
                </h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard </router-link>\ Book not returned
                </div>
              </div>

            </div>
          </div>
          <div class="card-body">
            <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
              <div class="row">
                <div class="col-md-4">
                  <v-text-field  v-on:keyup.enter="getAllNotReturnedBook()" autofocus outlined dense v-model="search.barcode"
                                 label="Student ID card no."></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-on:keyup.enter="getAllNotReturnedBook()" outlined dense v-model="search.name"
                                label="Symbol no., name, email"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-on:keyup.enter="getAllNotReturnedBook()" outlined dense v-model="search.book_no"
                                label="Book No"></v-text-field>
                </div>


                <v-col cols="2" md="2" class="text-right">
                  <v-btn
                      @click="getAllNotReturnedBook()"
                      class="btn btn-primary btn-search "
                      :loading="loading"
                  >
                    <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                    Search
                  </v-btn>
                </v-col>
                <!--        <div class="col-md-6">
                          <v-btn class="btn btn-primary mr-2 text-white" @click="getAllNotReturnedBook">Search</v-btn>
                          <v-btn class="btn btn-standard" @click="resetSearch">Reset</v-btn>
                          <v-btn class="btn btn-primary ml-2 text-white" @click="exportIssueList">Export</v-btn>
                        </div>-->
              </div>
            </div>
            <div class="table-responsive">
              <table class="table ">
                <thead>
                <tr class="px-3">
                  <th class="px-3">#</th>
                  <th class="px-3" style="max-width: 300px !important; white-space: pre-wrap;">Book title</th>
                  <th class="px-3"></th>
                  <th class="px-3">User detail</th>
                  <!--                  <th>Phone</th>-->
                  <th class="px-3">Dates</th>

                </tr>
                </thead>
                <tbody v-if="not_returned_books.length>0">
                <tr v-for="(iss, i) of not_returned_books" :key="i">
                  <td class="px-3">
                    <div v-if="iss.book_no" class="text-secondary">
                      {{ iss.book_no }}
                    </div>
                    <div v-if="iss.book_accession_no" class="text-secondary">
                      {{ iss.book_accession_no }}
                    </div>
                  </td>
                  <td class="px-3" style="max-width: 300px !important; white-space: pre-wrap;">
                    <a @click.prevent="openBookDetail(iss)" class="">
                      {{ iss.book_title }}
                    </a>
                    <div class="text-secondary">
                      <span class="font-weight-medium">{{ iss.book_author }}</span>
                    </div>
                  </td>
                  <td class="px-3"><img class="cursor-pointer img-thumbnail" @click="redirectTODetail(iss.user_id)" style="height: 80px"
                                        v-if="iss.user_image" :src="iss.user_image" alt="">
                    <span v-else>-</span>
                  </td>
                  <td style="cursor:pointer; color:blue"  @click="redirectTODetail(iss.user_id)">
                    <div class="text-secondary">
                      {{iss.user_id_card_no}} - {{iss.personal_id}}
                    </div>
                    <div class="text-secondary">
                      {{iss.user_full_name}}
                    </div>
                    <div class="text-secondary">
                      {{iss.program}}
                    </div>
                    <div class="text-secondary">
                      {{iss.grade}}  - {{iss.class}}
                    </div>
                  </td>
                  <!--                    <td>{{ iss.user_phone }}</td>-->
                  <td>
                    <div class="text-secondary">
                      <span class="badge badge-secondary">Issue date: {{iss.issue_date_text ? iss.issue_date_text : '-' }}</span>
                    </div>
                    <div class="text-secondary  mt-3">
              <span class="badge badge-secondary">Renew date: {{
                  iss.due_return_date_text ? iss.due_return_date_text : '-'
                }}</span>
                    </div>
                    <div class="text-secondary  mt-3">
              <span class="badge badge-secondary">Return date: {{iss.renew_date_text ? iss.renew_date_text : '-' }}
            </span>
                    </div>
                    <div class="text-secondary  mt-3 ml-2">
                      Overdue days: <span class="font-weight-medium " :class="iss.renew_required?'text-danger':'text-success'">
                  {{`${iss.renew_required ? '-' + iss.remaining_renew_day : iss.remaining_renew_day}` }}
                </span>
                    </div>
                  </td>


                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="10">
                    <p class="px-3 text-center">
                      <strong>No data found</strong>
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>
<script>
import IssueService from "@/core/services/library/issue/IssueService";
const issue = new IssueService();
export default {
  data(){
    return{
      page: 1,
      total: null,
      perPage: null,
      not_returned_books:[],
      loading: false,
      search: {
        status: null,
        dates: [],
        name: null,
        book_no: null,
        filter_by: 'all',

      }
    }
  },
  mounted() {
    this.getAllNotReturnedBook();
  },
  methods:{
    getAllNotReturnedBook(){
      this.loading = false;
        issue
            .getAllNotReturnedBook(this.search, this.page)
            .then(response => {
              this.not_returned_books=response.data.data;
              this.page = response.data.meta.current_page;
              this.total = response.data.meta.total;
              this.perPage = response.data.meta.per_page;
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
            });
    },
  }
}
</script>